import React, { useState } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import { useQzTrayClient } from '../../hooks/qztray/useQzTrayClient';
import { rawTestPayload } from '../../tests/qztray/rawTestPayload';
import PrintControlSection from '../../components/qztray/printTests/sections/PrintControlSection';
import PrinterListSection from '../../components/qztray/printTests/sections/PrinterListSection';
import TicketPreviewSection from '../../components/qztray/printTests/sections/TicketPreviewSection';
import TicketVisualPreview from '../../components/qztray/printTests/sections/TicketVisualPreview';
import { fakeBackendPayload } from '../../tests/qztray/fakeBackendPayload';
import PrintLogoSection from '../../components/qztray/printTests/sections/PrintLogoSection';
import PrintQrSection from '../../components/qztray/printTests/sections/PrintQrSection';

const QzTrayPrintTests: React.FC = () => {
  const { connectClient, discoverPrinters, print, isConnected } =
    useQzTrayClient();
  const [printer, setPrinter] = useState<string>('');
  const [printers, setPrinters] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      {/* === Contenedor tipo Card (modo claro / oscuro) === */}
      <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        {/* === Header del Panel === */}
        <div className="border-b border-stroke px-4 py-4 dark:border-strokedark sm:px-6 xl:px-7.5">
          <h3 className="flex items-center gap-2 text-lg font-semibold text-black dark:text-white">
            🧩 Pruebas de Impresión QZ Tray
          </h3>
          <p className="text-gray-600 dark:text-gray-400 mt-1 max-w-2xl text-sm">
            Ejecuta pruebas de conexión e impresión directa con comandos
            ESC/POS. Verifica las impresoras detectadas y visualiza la
            estructura RAW antes de imprimir.
          </p>
        </div>

        {/* === Contenido principal === */}
        <div className="space-y-10 p-4 sm:p-6 xl:p-10">
          {/* === Secciones principales === */}
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
            <PrintControlSection
              connectClient={connectClient}
              discoverPrinters={discoverPrinters}
              print={print}
              isConnected={isConnected}
              printer={printer}
              setPrinter={setPrinter}
              setPrinters={setPrinters}
              printers={printers}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              rawTestPayload={rawTestPayload}
            />

            <PrintLogoSection
              connectClient={connectClient}
              discoverPrinters={discoverPrinters}
              print={print}
              isConnected={isConnected}
              printer={printer}
              setPrinter={setPrinter}
              setPrinters={setPrinters}
              printers={printers}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />

            <PrintQrSection
              connectClient={connectClient}
              discoverPrinters={discoverPrinters}
              print={print}
              isConnected={isConnected}
              printer={printer}
              setPrinter={setPrinter}
              setPrinters={setPrinters}
              printers={printers}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />

            <PrinterListSection
              printers={printers}
              printer={printer}
              setPrinter={setPrinter}
            />

            <TicketPreviewSection commands={rawTestPayload.commands} />

            <TicketVisualPreview commands={fakeBackendPayload.data.commands} />

          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default QzTrayPrintTests;
